// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#current_user_theme {
    line-height: 12px;
    height: 20px;
    text-align: right;
    right: 5.4em;
    top: 27px;
    box-sizing: border-box;
    color: var(--panel-text-color);
    font-size: 11px;
    font-weight: normal;
    padding: 0;
    position: absolute;
    z-index: 1000;
    border: solid 1px rgba(0, 0, 0, 0.0);
}

#current_user_theme > span.login {
    font-weight: bold;
    cursor: pointer;
}

#current_user_theme > span.username {
    white-space: no-wrap;
}

#current_user_theme > span.theme {
    white-space: no-wrap;
}

div.infotext {
    font-size: 12px;
    margin: 10px 5px;
    text-align: center;
    color: var(--text-color);
    height: 3.8em;
    vertical-align: middle;
    display: table-cell;
    width: 23em;
}

div.infotext > span {
    font-weight: bold;
}

.anmelden_button {
    font-size: 13px;
    font-weight: bold;
    color: var(--button-text-color-active-hover);
    background-color: #002c77;
    width: 19.5em;
    height: 2.2em;
    margin: 0px 10px;
    display: inline-block;
    text-align: center;
    padding-top: 8px;
}

.anmelden_button:hover {
    text-decoration: none;
    background-color: var(--button-bg-color-active-hover);
}

div.current_user_info {
    position: absolute;
    top: 49px;
    right: 0;
    width: 19.5em;
    height: 6em;
    z-index: 90;
    background-color: rgba(255, 255, 255, 0.9);
    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);
}

.icon-user_known {
    color: #595959;
    position: relative;
    top: 2px;
}

.icon-user_unknown {
    color: #595959;
    position: relative;
    top: 2px;
}

#logoInMap {
    position: absolute;
    background-color: #FFFFFFBB;
    width: 4em;
    bottom: 2.5em;
    right: 0.5em;
    border-radius: 4px;
    bbox-shadow: 0 0 10px #FFFFFFBB;
    z-index: 100;
}

`, "",{"version":3,"sources":["webpack://./js/plugins/style/ThemeUsernameTopbar.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,SAAS;IACT,sBAAsB;IACtB,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,4CAA4C;IAC5C,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,qDAAqD;AACzD;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,aAAa;IACb,WAAW;IACX,WAAW;IACX,0CAA0C;IAC1C,gDAAgD;AACpD;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,UAAU;IACV,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;IAC/B,YAAY;AAChB","sourcesContent":["#current_user_theme {\n    line-height: 12px;\n    height: 20px;\n    text-align: right;\n    right: 5.4em;\n    top: 27px;\n    box-sizing: border-box;\n    color: var(--panel-text-color);\n    font-size: 11px;\n    font-weight: normal;\n    padding: 0;\n    position: absolute;\n    z-index: 1000;\n    border: solid 1px rgba(0, 0, 0, 0.0);\n}\n\n#current_user_theme > span.login {\n    font-weight: bold;\n    cursor: pointer;\n}\n\n#current_user_theme > span.username {\n    white-space: no-wrap;\n}\n\n#current_user_theme > span.theme {\n    white-space: no-wrap;\n}\n\ndiv.infotext {\n    font-size: 12px;\n    margin: 10px 5px;\n    text-align: center;\n    color: var(--text-color);\n    height: 3.8em;\n    vertical-align: middle;\n    display: table-cell;\n    width: 23em;\n}\n\ndiv.infotext > span {\n    font-weight: bold;\n}\n\n.anmelden_button {\n    font-size: 13px;\n    font-weight: bold;\n    color: var(--button-text-color-active-hover);\n    background-color: #002c77;\n    width: 19.5em;\n    height: 2.2em;\n    margin: 0px 10px;\n    display: inline-block;\n    text-align: center;\n    padding-top: 8px;\n}\n\n.anmelden_button:hover {\n    text-decoration: none;\n    background-color: var(--button-bg-color-active-hover);\n}\n\ndiv.current_user_info {\n    position: absolute;\n    top: 49px;\n    right: 0;\n    width: 19.5em;\n    height: 6em;\n    z-index: 90;\n    background-color: rgba(255, 255, 255, 0.9);\n    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);\n}\n\n.icon-user_known {\n    color: #595959;\n    position: relative;\n    top: 2px;\n}\n\n.icon-user_unknown {\n    color: #595959;\n    position: relative;\n    top: 2px;\n}\n\n#logoInMap {\n    position: absolute;\n    background-color: #FFFFFFBB;\n    width: 4em;\n    bottom: 2.5em;\n    right: 0.5em;\n    border-radius: 4px;\n    bbox-shadow: 0 0 10px #FFFFFFBB;\n    z-index: 100;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
